import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "12",
  height: "21",
  viewBox: "0 0 12 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M0.563034 9.66896C0.131811 10.1302 0.131812 10.8467 0.563034 11.308L8.93372 20.2616C9.408 20.7689 10.2126 20.7689 10.6869 20.2616L11.3981 19.5008C11.829 19.0399 11.8294 18.3241 11.399 17.8627L5.28347 11.307C4.85344 10.846 4.85344 10.1309 5.28347 9.66992L11.399 3.11421C11.8294 2.65285 11.829 1.93702 11.3981 1.47614L10.6869 0.715357C10.2126 0.208042 9.408 0.20804 8.93372 0.715357L0.563034 9.66896Z",
  fill: "#FEFEFE"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };